export const getReportMode = reportPayload => {
  if (reportPayload?.mode) return reportPayload.mode;

  if (reportPayload?.report_type === "multi_project_billing_roll_up_only") {
    return "roll_up_only";
  }

  if (reportPayload?.report_type === "multi_project_billing_operational_activity") {
    return "operational_activity";
  }

  return null;
};

const addFilterValue = (filtersObject, type, value) => {
  if (!type || value === undefined || value === null || value === "") return;

  if (!filtersObject[type]) filtersObject[type] = [];
  filtersObject[type] = [value, ...filtersObject[type]];
};

const formatReportDate = date => {
  if (!date) return null;
  if (typeof date === "string") return date;
  if (typeof date.format === "function") return date.format("MM/DD/YYYY");

  return date;
};

export const buildReportGenerationVariables = ({
  favoriteReportId,
  reportPayload,
  baseFilters = [],
  modalValues = {},
}) => {
  if (!favoriteReportId) {
    throw new Error("favoriteReportId is required to generate a report");
  }

  const filters = {};
  baseFilters.forEach(({ type, value }) => addFilterValue(filters, type, value));

  (modalValues.assetFieldFilters || []).forEach(({ type, value }) => {
    addFilterValue(filters, type, value);
  });

  const startDate = formatReportDate(modalValues.startDate);
  const endDate = formatReportDate(modalValues.endDate);
  const inventoryAsOfDate = formatReportDate(modalValues.inventoryAsOfDate);

  if (startDate) filters.start_date = startDate;
  if (endDate) filters.end_date = endDate;
  if (inventoryAsOfDate) filters.inventory_as_of_date = inventoryAsOfDate;

  if (modalValues.warehouseId) {
    filters.warehouse_id = Array.isArray(modalValues.warehouseId)
      ? modalValues.warehouseId
      : [modalValues.warehouseId];
  }

  if (modalValues.costCenterId) {
    filters.cost_center_id = Array.isArray(modalValues.costCenterId)
      ? modalValues.costCenterId
      : [modalValues.costCenterId];
  }

  const variables = {
    favoriteReportId,
    mode: getReportMode(reportPayload),
    filters,
    receivingNotes: modalValues.receivingNotes,
  };

  if (modalValues.projectIds && modalValues.projectIds.length > 0) {
    variables.projectIds = modalValues.projectIds;
    if (modalValues.clientId) variables.clientId = modalValues.clientId;
  } else if (modalValues.clientId && !modalValues.projectId) {
    variables.clientId = modalValues.clientId;
  } else if (modalValues.projectId !== undefined) {
    variables.projectId = modalValues.projectId;
  } else {
    variables.projectId = null;
  }

  return variables;
};

export const shouldGenerateReportByClient = variables =>
  !!variables.clientId && variables.projectId === undefined && !variables.projectIds;
